import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { flow, initial, last, lowerCase, map, upperFirst } from 'lodash4';
import { StudentValueModel } from '../../../../../global/components/student_value/model/student_value_model';
import { APModel } from '../../../../../global/models/ap_model';
import { APPreviewPlanServant } from '../../../../../preferences/components/preview_plan/components/preview_terms_plan_header/servants/ap_preview_plan_servant';

const termCommitmentUITextStrategy = {
  FULL_TIME: 'Full Time',
  PART_TIME: 'Part Time'
};

class PreviewAutoGeneratedTermsHeader {
  private terms: any[];
  private estimatedGraduationTime: string;
  private termPreference: string[];
  private termCommitment: string;

  private mappedTermCommitmentString: string;
  private mappedTermPreferenceString: string;
  private isAdvisor: boolean = false;
  private duration: string;

  private programName: string;
  private programCredits: number;
  private pageType: string;

  constructor(
    private ngAPModel: APModel,
    private completedAutoGeneratedPreviewPlanShowingCommand: ICommand,
    private ngStudentValueModel: StudentValueModel,
    private ngPreviewTermPlanConstant: ng.IServiceProvider,
    private $state: ng.ui.IStateService
  ) {}
  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  initialize() {
    this.isAdvisor = this.$state.includes('ap-advisor');
    const program = _4.first(_4.toArray(this.ngAPModel.read().program));
    const startingDateOfFirstTerm: any = _4(this.terms).map('term_start_dt').min();
    const endDateOfLastTerm: any = _4(this.terms).map('term_end_dt').max();
    this.pageType = this.$state.current.url === 'auto_generated/' ? 'autoGenerated' : 'editPreferences';
    this.duration = moment.duration(endDateOfLastTerm.diff(startingDateOfFirstTerm)).humanize();
    this.programName = program.name;
    this.programCredits = parseInt(program.credits, 10);
    const _upperFirst = flow(lowerCase, upperFirst);
    this.mappedTermCommitmentString = _4.lowerCase(termCommitmentUITextStrategy[this.termCommitment]);
    this.mappedTermPreferenceString =
      initial(this.termPreference)
        .map((preference: string) => _upperFirst(preference))
        .join(', ') +
      ' and ' +
      _upperFirst(last(this.termPreference));

    this.estimatedGraduationTime = APPreviewPlanServant.getEstimatedGraduationDateFromTerm(this.terms);
  }

  updateApPreviewShownModel() {
    const currentStudentValue = {};
    this.ngStudentValueModel
      .keys()
      .forEach((key: string) => (currentStudentValue[key] = this.ngStudentValueModel.getValueByKey(key)));
    currentStudentValue[this.ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN']] = 'True';
    this.ngStudentValueModel.update(currentStudentValue);
  }

  completedAutoGeneratedPreviewPlanShowing() {
    this.updateApPreviewShownModel();
    if (this.isAdvisor) {
      return this.$state.go('ap-advisor.plan');
    }
    return this.$state.go('my.planner.default');
  }

  afterSaving() {
    this.completedAutoGeneratedPreviewPlanShowingCommand().then(() => this.completedAutoGeneratedPreviewPlanShowing());
  }

  createMyOwnPlanClicked() {
    this.completedAutoGeneratedPreviewPlanShowingCommand().then(() => {
      this.updateApPreviewShownModel();
      if (this.isAdvisor) {
        return this.$state.go('ap-advisor.preview_plan.edit_preference');
      }
      return this.$state.go('my.planner.preview_plan.edit_preference', { source: 'autoGenerated' });
    });
  }
}

angular.module('capability-ng-academic-planner').component('previewAutoGeneratedTermsHeader', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_auto_generated_terms_header/preview_auto_generated_terms_header.html',
  bindings: {
    terms: '<',
    estimatedGraduationTime: '<',
    termCommitment: '<',
    termPreference: '<'
  },
  controller: PreviewAutoGeneratedTermsHeader
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_auto_generated_terms_header/preview_auto_generated_terms_header.ts